module.exports = __webpack_public_path__ + "images/menu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu.svg
// module id = 1127
// module chunks = 0